export default __webpack_public_path__ + "static/media/_DSC2078.595e8453.jpg";